import { render, staticRenderFns } from "./EvaluateSampleCreate.vue?vue&type=template&id=76bfacae&scoped=true"
import script from "./EvaluateSampleCreate.vue?vue&type=script&lang=js"
export * from "./EvaluateSampleCreate.vue?vue&type=script&lang=js"
import style0 from "./EvaluateSampleCreate.vue?vue&type=style&index=0&id=76bfacae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bfacae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76bfacae')) {
      api.createRecord('76bfacae', component.options)
    } else {
      api.reload('76bfacae', component.options)
    }
    module.hot.accept("./EvaluateSampleCreate.vue?vue&type=template&id=76bfacae&scoped=true", function () {
      api.rerender('76bfacae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/EvaluateSampleCreate.vue"
export default component.exports